// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-VacancyAvatar-module--cls1--3a2lC","cls2":"styles-VacancyAvatar-module--cls2--3OI2H styles-VacancyAvatar-module--cls1--3a2lC"};